import React from 'react';

export default function usePickupAddress() {
    const defaultAddress = "14C Woodall Place, Totara Vale, Auckland 0627";
    return process.env.GATSBY_PICKUP_ADDRESS ?? defaultAddress;
}
